import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MceSettings } from 'app/core/mce-config/mce-editor-config.constant';
import { UserInterface } from 'app/core/user/models';
import { RecommendationInterface } from 'app/recommendation/models';
import { RecommendationCategoryMulti } from 'app/recommendation/models/recommendation-category-multi.model';
import { recommendationItemsMullangItem } from 'app/recommendation/models/recommendation-item-multi.model';
import { stringDecodeToHtml } from 'app/shared/utilities/utility-methods.utility';
import { environment } from 'environments/environment.prod';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';


@Component({
  selector: 'cz-edit-evaluation-recommendation',
  templateUrl: './edit-evaluation-recommendation.component.html',
  styleUrls: ['./edit-evaluation-recommendation.component.scss'],
})
export class EditEvaluationRecommendationComponent implements OnInit, OnDestroy {
  public recomandationId:number;
  @Input() public saved$: BehaviorSubject<Readonly<boolean>>;
  @Input() public open: boolean;
  @Input() public item: RecommendationInterface;
  @Input() public readonly currentUser: UserInterface;
  @Input() public readonly readOnly: boolean;
  @Input() public readonly form: FormGroup;
  @Input() public cultureCookie:number;
  @Input() public backupLanguageId:number;
  @Input() public recommendationsMultiLanguage: recommendationItemsMullangItem[];

  @Output() public updateRecommendation: EventEmitter<RecommendationInterface> =
  new EventEmitter<RecommendationInterface>();

  @Output() public recommendationRemoved: EventEmitter<RecommendationInterface> =
  new EventEmitter<RecommendationInterface>();

  public tinyApiKey: string = environment.tinyMceKey;
  public readonlyConfig: any = MceSettings.readonlyDisplay;
  public tinyConfig: any = MceSettings.default;
  public config: any = '';
  public readonlyText:string = '';
  public isEdited:boolean;

  public priorityControl: FormControl = new FormControl('');
  public ergoDetailsControl: FormControl = new FormControl('');
  public templateTextControl: FormControl = new FormControl('');

  public priorityList: { label: string, value: number }[] = [
    {
      label: '$hight',
      value: 1,
    },
    {
      label: '$mediumt',
      value: 2,
    },
    {
      label: '$lowt',
      value: 3,
    },
  ];
  public imageFileNameDisplay:boolean = false;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  constructor(private readonly _translateService: TranslateService) {}

  public ngOnInit(): void {
    if(this.readOnly) {
      this.open = true;
    }
    this.setFormData();
    this.saved$.pipe(takeUntil(this.destroy$))
    .subscribe((isSaved: boolean) => {
      if(isSaved) {
        const updatedRecommendation: RecommendationInterface = {
          ...this.item,
          isEdited: (this.item.isEdited || (this.recomandationId && this.recomandationId===this.item.id))? true:false,
          priority: this.priorityControl.value,
          text: btoa(this.templateTextControl.value),
        };
        this.updateRecommendation.emit(updatedRecommendation);
        this.saved$.next(false);
      }
    });

    if (this.recommendationsMultiLanguage) {
      const text: string = this.itemText(this.item);
      this.readonlyText = (text && text!=='') ? stringDecodeToHtml(text) : this._translateService.instant('$common_no_translation');
    }
  }

  public ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  /**
   * Remove the provided recommendation item from the recommendations list.
   *
   * @param item Item to remove from the newRecommendation
   */
  public removeRecommendation(item: RecommendationInterface): void {
    // Alert listeners to change in recommendation.
    this.recommendationRemoved.emit(item);
  }

  public onEditorChange(value: any): void {
    const formGroup: FormGroup = this.form as FormGroup;
    formGroup.markAsDirty();
  }
  public itemText(item: RecommendationInterface):string {
    let text: string = '';
    let temptext: string = '';
    let flag: number = 0;
    // if item Edited then taking the employee_recommendation text
    if(item.isEdited) {
      text = item.text;
    } else {
      item.recommendationMullang.map((list: recommendationItemsMullangItem) => {
        if (list.languageId === this.cultureCookie && list.text !== '' && list.text !== null && list.text !== undefined && flag === 0) {
          text = list.text;
          flag = 1;
        } else if (this.backupLanguageId === list.languageId && flag === 0) {
          temptext = list.text;
        }
      });
      if (flag === 1) {
        text = text;
      } else {
        text = (temptext && temptext !== '') ? temptext : '';
      }
    }
    return text;
  }
  public recomandationEdit(): void {
    this.isEdited = true;
    this.config = this.tinyConfig;
    this.priorityControl.enable();
    this.templateTextControl.enable();
    this.recomandationId = 0;
    this.recomandationId = this.item.id;
    this.onEditorChange(null);
  }
  public getCategoryName(multicategory:RecommendationCategoryMulti[]): string {
    let name: string = '';
    let tempName:string = '';
    let flag: number = 0;
    multicategory.map((list: RecommendationCategoryMulti)=> {
      if (this.cultureCookie === list.languageId && list.title !== '' && list.title !== null && list.title !== undefined && flag === 0) {
        flag= 1;
        name= list.title;
      } else if (this.backupLanguageId === list.languageId && flag === 0) {
        tempName = list.title;
      }

    });
    if (flag === 1) {
      name = name;
    } else {
      name = (tempName && tempName !== '') ? tempName : this._translateService.instant('$common_no_translation');
    }
    return name;
  }

  public itemName(item: RecommendationInterface): string {
    let title: string = '';
    let temptitle: string = '';
    let flag: number = 0;
    // if item Edited then taking the employee_recommendation text

    item.recommendationMullang.map((list: recommendationItemsMullangItem) => {
      if (list.languageId === this.cultureCookie && list.title !== '' && list.title !== null && list.title !== undefined && flag === 0) {
        title = list.title;
        flag = 1;
      } else if (this.backupLanguageId === list.languageId && flag === 0) {
        temptitle = list.title;
      }
    });
    if (flag === 1) {
      title = title;
    } else {
      title = (temptitle && temptitle !== '') ? temptitle : this._translateService.instant('$common_no_translation');
    }

    return title;
  }
  public isImageValid(event:any): void {
    (event.target as HTMLImageElement).parentElement.style.display = 'none';
    this.imageFileNameDisplay = true;
  }

  private setFormData(): void {
    this.isEdited= true;
    this.priorityControl.patchValue(this.item.priority);
    const text: string = this.itemText(this.item);
    if (text !== '') {
      this.templateTextControl.patchValue(stringDecodeToHtml(text));
    } else {
      this.templateTextControl.patchValue(this._translateService.instant('$common_no_translation'));
    }

    if (!this.item.isEdited) {
      this.isEdited = false;
      this.config = this.tinyConfig;
      // this.priorityControl.disable();
    }
    if (this.readOnly) {
      this.isEdited= false;
      this.priorityControl.disable();
      this.templateTextControl.disable();

    }
  }
}
